import UriUtils from "../utils/UriUtils";

// TODO RCH : refactor by using sp-react-commons (first, we need to support passing headers like 'X-Requested-With' for each request)

let AuthApi = {
    logoutAllUri: (maybeRedirect) => (
        new UriUtils("/logoutAll")
            .addQueryParam("redirectUri", maybeRedirect)
            .build()
    ),
    loginUri: "/login",
    oauthLoginUri: (maybeLang, apiVersion = 1) => (
        new UriUtils(`/sso/v${apiVersion}/login`)
            .addQueryParam("maybeLang", maybeLang)
            .build()
    ),
    socialLoginUri: (socialId, apiVersion = 1) => `/sociallogin?apiVersion=${apiVersion}&socialId=${socialId}`,
    oauthSocialLoginUri: (socialId, maybeLang, apiVersion = 1) => (
        new UriUtils(`/sso/v${apiVersion}/sociallogin?socialId=${socialId}`)
            .addQueryParam("maybeLang", maybeLang)
            .build()
    )
};

let UserApi = {
    baseUrl: "/user/api/users",
    checkEmail: function(email) {
        return $.ajax({
            type: 'GET',
            url: `${this.baseUrl}/checkEmail?email=${email}`,
            contentType: 'application/json',
            dataType: 'json'
        });
    }
};

export {
    AuthApi,
    UserApi
};


// WEBPACK FOOTER //
// ./js/api/Api.js